import PlanImage from '../assets/images/telsim-nbn-banner.png';
import BackgroundImg from '../assets/images/telsim-australia-sim-plans.webp';
import Header from '../components/Header';


const styles = {
    hero: {
        width: '100%',
        height: '800px',
        background: `url(${BackgroundImg}) top center no-repeat`,
        backgroundSize: 'cover',
    }
};

function HeaderBanner() {
    return (
        <>
        <Header />
        {/* ======= Hero Section ======= */}
        <section id="hero" className="hero d-flex align-items-center" style={styles.hero}>
          <div className="container">
            <div className="row ctm-matgin-top">
              <div className="col-lg-6 hero-img">
                <img src={PlanImage} className="img-fluid" alt="" />
              </div>
              <div className="col-lg-6 d-flex d-ctm-flex flex-column justify-content-center">
              <h1>NBN NETWORK PLANS AT BEST PRICES, </h1>
              <h2 style={{ fontSize: '18px', color: '#333' }}>FEATURING FANTASTIC HOME INTERNET PACKAGES AND DEALS.</h2>
                <h5 style={{ color: '#777' }}>
                Transforming connectivity across Australia, Telsim NBN<sup>&reg;</sup> <span></span>plans offer unparalleled speed, accessibility, and coverage, setting a new standard in connectivity.
                </h5>
                
                
                <div>
                  <div className="text-center text-lg-start">
                    <a
                      href="#AdressSelectBox"
                      className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center"
                    >
                      <span>Check Address Now</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Hero */}
      </>
      
    );
}

export default HeaderBanner;
